import React from 'react';

const SvgNotificationtray = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 16 20" ref={svgRef} {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <defs>
      <path
        id="notificationtray_svg__a"
        d="M1070 36.846v-5.128c0-3.149-1.64-5.785-4.5-6.482v-.698c0-.85-.67-1.538-1.5-1.538s-1.5.687-1.5 1.538v.698c-2.87.697-4.5 3.323-4.5 6.482v5.128l-2 2.051v1.026h16v-1.026zM1064 43c1.1 0 2-.923 2-2.051h-4c0 1.128.89 2.051 2 2.051z"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#notificationtray_svg__a" transform="translate(-1056 -23)" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgNotificationtray svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/NotificationTray.js